export default __webpack_public_path__ + "beecf6cbc9b4f478ab153b132c674f06.ttf";